import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observable, extendObservable } from 'mobx'
import { observer } from 'mobx-react'
import { autobind } from 'core-decorators'

import IndexList from '../../shared/components/IndexList'
import ColumnList from '../../shared/components/ColumnList'
import ListEntry from './ListEntry'
import Filter from '../../shared/ListFilter'

import { deepGet } from '../../shared/utils'

@observer
export default class List extends Component {

  static propTypes = {
    auth: PropTypes.object,
    store: PropTypes.object,
  }

  getList() {
    const filterText = this.filter.text.trim().toLowerCase()
    const onlyWithHostel = this.filter.onlyWithHostel
    return this.props.store.collection.filter((entry) => {
      return onlyWithHostel ? !!entry.hostelUrl : true
    })
      .filter((entry) => {
        if (!filterText) {
          return true
        }
        const name = `${entry.title}`
        return name.toLowerCase().indexOf(filterText) !== -1
      })
  }

  @observable filter = {
    text: '',
    onlyWithHostel: false
  }

  @autobind
  handleFilterChange(newFilter) {
    extendObservable(this.filter, newFilter)
  }

  renderEntry(props) {
    const { entry, ...rest } = props
    return (
      <ListEntry
        program={entry}
        {...rest}
        showMuseum
      />
    )
  }

  render() {

    const { store, auth } = this.props
    const currentUserMuseum = deepGet(auth, 'user.museumId')

    const filteredList = this.getList()

    return (
      <div className="app-pane pane column-xl">
        <div
          className="vertical"
        >
          <div
            className="header clearfix"
          >
            <Filter
              list={store.collection}
              filter={this.filter}
              onChange={this.handleFilterChange}
            />

            <h1>Alle Programme</h1>
          </div>

          <IndexList
            list={filteredList}
            keyString="sanitizedOrderTitle"
            className="program-initials"
          />

          <ColumnList
            list={filteredList}
            currentUserMuseum={currentUserMuseum}
            keyString="sanitizedOrderTitle"
            className="program-list"
            renderEntry={this.renderEntry}
          />

        </div>
      </div>
    )

  }

}



// WEBPACK FOOTER //
// ./src/program/components/List.js